module.exports = __webpack_public_path__ + "img/portfolio1.417a4ec9.png";